// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_u7j","cls2":"SearchBox-cls2_QBb SearchBox-cls1_u7j"};